import React, { useMemo } from 'react';
import { useTimezone, TIMEZONE_OPTIONS } from '@/contexts/TimezoneContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/ui/dropdown-menu';
import { Button } from '@/ui/button';
import { Icon } from '@/components/icon';

export const TimezoneSelector: React.FC = () => {
  const { timezone, setTimezone } = useTimezone();
  
  // Find the current timezone label
  const currentTimezoneLabel = useMemo(() => {
    const option = TIMEZONE_OPTIONS.find(opt => opt.value === timezone);
    return option ? option.label : timezone;
  }, [timezone]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 px-2 cursor-pointer">
          <Icon icon="mdi:clock-time-five-outline" size={16} className="mr-2" />
          <span className="hidden md:inline">Timezone:</span>{' '}
          <span className="font-medium">{currentTimezoneLabel}</span>
          <Icon icon="mdi:chevron-down" size={16} className="ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[220px]">
        {TIMEZONE_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.value}
            className={`cursor-pointer ${timezone === option.value ? 'font-medium bg-muted' : ''}`}
            onClick={() => setTimezone(option.value)}
          >
            {option.label}
            {timezone === option.value && (
              <Icon icon="mdi:check" size={16} className="ml-auto" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};